import useAxios from "./use-axios";

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useSendForgotPassword = () => {
  return useAxios(
    {
      url: `/forgot-password`,
      method: "POST",
    },
    { manual: true }
  );
};

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useIsExpiredResetPassword = () => {
  return useAxios(
    {
      url: `/forgot-password/is-expired`,
      method: "POST",
    },
    { manual: true }
  );
};

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useResetPassword = () => {
  return useAxios(
    {
      url: `/forgot-password/reset`,
      method: "POST",
    },
    { manual: true }
  );
};
